import React from 'react';
import { IQRCodeScanDetector } from './eiq-secure-qr-code-scan-detector.types';
import { startEndChar } from 'common/helpers/eiq-passport.helper';

const timeBeforeScanCheck = 100;
const length = 8;
const timeByChar = 30;

const startChars = [startEndChar];
const endKeys = ['Tab', 'Enter', '\n', '\r', '\r\n'];
const endKeyCodes = [10, 13, 9];

const startEndCharCode = startEndChar.charCodeAt(0);

class QRCodeScanDetector extends React.Component<IQRCodeScanDetector, any> {
  firstCharTime: number;
  lastCharTime: number;
  resultString: string;
  isScanner: boolean;
  timer: any;
  isStartEndCharDetected: boolean;

  constructor(props: IQRCodeScanDetector) {
    super(props);

    this.firstCharTime = 0;
    this.lastCharTime = 0;
    this.resultString = '';
    this.isScanner = false;
    this.timer = null;
    this.isStartEndCharDetected = false;
  }

  componentDidMount() {
    window.document.addEventListener('keydown', this.handleKeyPress, true);
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this.handleKeyPress, true);
  }

  reset = () => {
    this.firstCharTime = 0;
    this.resultString = '';
    this.isStartEndCharDetected = false;
  };

  scannerDetectionTest = () => {
    const { onScan } = this.props;

    if (this.resultString.length >= length && this.lastCharTime - this.firstCharTime < this.resultString.length * timeByChar) {
      if (onScan) {
        onScan(this.resultString.replaceAll('|', ''));
      }
    }

    this.reset();
  };

  handleKeyPress = (event: KeyboardEvent) => {
    const key = event.key;

    if (key === startEndChar || event.which === startEndCharCode) {
      this.isStartEndCharDetected = true;
    }

    if (this.isStartEndCharDetected) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.firstCharTime && (endKeys.includes(key) || endKeyCodes.includes(event.which))) {
      event.preventDefault();
      event.stopPropagation();
      this.isScanner = true;
    } else if (!this.firstCharTime && startChars.includes(key)) {
      event.preventDefault();
      event.stopPropagation();
      this.isScanner = false;
    } else {
      if (key.length === 1) {
        this.resultString += key;
      }
      this.isScanner = false;
    }

    if (!this.firstCharTime) {
      this.firstCharTime = Date.now();
    }

    this.lastCharTime = Date.now();

    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (this.isScanner) {
      this.scannerDetectionTest();
      this.timer = null;
    } else {
      this.timer = setTimeout(this.scannerDetectionTest, timeBeforeScanCheck);
    }
  };

  render() {
    return null;
  }
}

export default QRCodeScanDetector;
